import React from 'react';
import {  NavLink } from 'react-router-i18n';
import i18n from '../../assets/locales/I18n';
import { Trans } from 'react-i18next';
import './header.css';

 function Menu ({ location: { pathname }, match: { params: { locale } }, history}) {

    const stripLocale = (pathname, locale) => {
        if (!locale) {
          return pathname;
        }

        i18n.changeLanguage(locale);
        return pathname.replace(`/${locale}`, '');
        
    };

  return (
    
    <header className="navbar navbar-expand-lg header_area" id="header" >
        <div className='container'>
            <a href="https://www.dreamcodesoft.com" className="navbar-brand " >
                <img className="logoBlue" src={require("./../../img/logo-blue.png")} alt="logo DreamCode Software" title="Logo DreamCode Software" width="164"/>
            </a>            
            <div className="justify-content-end" id="OnePageManuContent">
                <ul className='navbar-nav pl-4 '>
                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" href="/" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-expanded="false">
                            <i className="ti-world w_color"></i>
                        </a>
                        <div className="dropdown-menu" >
                             <NavLink className="dropdown-item" ignoreLocale to={`/es${stripLocale(pathname, locale)}`}>
                                <Trans i18nKey="menu.spanish">Spanish</Trans>
                            </NavLink> 
                            <NavLink className="dropdown-item" ignoreLocale to={`/en${stripLocale(pathname, locale)}`}>
                                <Trans i18nKey="menu.english">English</Trans>
                            </NavLink>
                        </div>
                    </li>
                </ul>   

            </div>
        </div>
    </header>
    
  )
}

export default Menu;